export default __webpack_public_path__ + "static/media/dropdown.arrow.394afc4d.svg";